<template>
    <component :is="innerUseage ? 'div' : PublicProfileLayout" :role="role" :inner-usage="innerUseage">
        <div v-if="loading" class="card flex justify-content-center">
            <ProgressSpinner />
        </div>
        <div class="grid flex flex-column justify-content-center align-items-center min-h-screen px-2 w-full" v-else>
            <div class="back-section flex flex-wrap align-self-start pt-2">
                <Button icon="pi pi-arrow-left" label="Back" class="p-button-text Caption back-button mb-2 " @click="goBack"/>
            </div>
            <!-- Title -->
            <div class="col-12 flex flex-column justify-content-center align-items-center">
                <h2 class="text-2xl font-semibold ">Request a Class</h2>
            </div>

            <!-- Form Grid -->
            <!-- <div class="grid justify-content-center align-items-center w-full"> -->
            <div class="grid justify-content-center align-items-stretch w-full">
                <!-- Left Column -->
                <div class="p-3 flex flex-column col-12 lg:col-5 surface-border">

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="grade" class="Label align-self-start">Grade</label>
                        <Select v-model="grade" :options="allGrades" optionLabel="name"
                            placeholder="Select your grade here" class="w-full" show-clear size="small"
                            variant="filled" :invalid="!!errors.grade" />
                        <small class="error-text-block">{{ errors.grade }}</small>
                    </div>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="language" class="Label align-self-start">Language</label>
                        <Select v-model="language" :options="languages" optionLabel="name" optionValue="code"
                            placeholder="Select your language here" class="w-full" show-clear size="small"
                            variant="filled" :invalid="!!errors.language" />
                        <small class="error-text-block">{{ errors.language }}</small>
                    </div>

                    <!-- <div class="flex flex-column gap-2 mb-5 relative">
                        <label for="location" class="Label align-self-start">Class Location</label>
                        <Select v-model="location" :options="locations" optionLabel="name" optionValue="code"
                            placeholder="Select your class location here" class="w-full" show-clear size="small"
                            variant="filled" :disabled="classType !== 'physical'" />
                        <small v-if="errors.location" class="error-text">{{ errors.location }}</small>
                    </div> -->

                    <!-- <div class="flex flex-column gap-2 mb-5 relative">
                        <label for="date" class="Label align-self-start">Date</label>
                        <DatePicker v-model="date" dateFormat="dd/mm/yy" showIcon iconDisplay="input" variant="filled"
                            inputClass="w-full" class="w-full" size="small" placeholder="Select your class date here" />
                        <small v-if="errors.date" class="error-text">{{ errors.date }}</small>
                    </div> -->

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="classModel" class="Label align-self-start">Class Model</label>
                        <Select v-model="classModel" :options="classModels" optionLabel="name" optionValue="code"
                            placeholder="Select your class model here" class="w-full" show-clear size="small"
                            variant="filled" :invalid="!!errors.classModel" :disabled="!subject" />
                        <small class="error-text-block">{{ errors.classModel }}</small>
                    </div>
                </div>

                <!-- Right Column -->
                <!-- <div class="p-3 flex flex-column col-12 lg:col-5 surface-border"> -->
                <div class="p-3 flex flex-column col-12 lg:col-5 surface-border">

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="subject" class="Label align-self-start">Subject</label>
                        <Select v-model="subject" :options="subjects" optionLabel="name" optionValue="code"
                            placeholder="Select your subject here" class="w-full" show-clear :disabled="!grade"
                            size="small" variant="filled" :invalid="!!errors.subject" />
                        <small class="error-text-block">{{ errors.subject }}</small>
                    </div>

                    <!-- <div class="flex flex-column gap-2 mb-5 relative">
                        <label for="classType" class="Label align-self-start">Class Type</label>
                        <Select v-model="classType" :options="classTypes" optionLabel="name" optionValue="value"
                            placeholder="Select your class type here" class="w-full" show-clear size="small"
                            variant="filled" />
                        <small v-if="errors.classType" class="error-text">{{ errors.classType }}</small>
                    </div> -->

                    <!-- <div class="flex flex-column gap-2 mb-5 relative">
                        <label for="address" class="Label align-self-start">Location Address</label>
                        <InputText id="address" type="text" placeholder="Type location address here" variant="filled"
                            class="w-full" v-model="address" :disabled="location !== 'students_place'" size="small" />
                        <small v-if="errors.address" class="error-text">{{ errors.address }}</small>
                    </div> -->

                    <!-- <div class="grid">
                        <div class="col-6 flex flex-column gap-2 mb-5 relative">
                            <label for="start" class="Label align-self-start">Start Time</label>
                            <DatePicker v-model="start" timeOnly hourFormat="12" showIcon iconDisplay="input"
                                variant="filled" inputClass="w-full " class="w-full" size="small"
                                placeholder="Start time" />
                            <small v-if="errors.start" class="error-text">{{ errors.start }}</small>
                        </div>

                        <div class="col-6 flex flex-column gap-2 mb-5 relative">
                            <label for="end" class="Label align-self-start">End Time</label>
                            <DatePicker v-model="end" timeOnly hourFormat="12" showIcon iconDisplay="input"
                                variant="filled" inputClass="w-full " class="w-full" size="small"
                                placeholder="End time" />
                            <small v-if="errors.end" class="error-text">{{ errors.end }}</small>
                        </div>
                    </div> -->

                    <div class="hidden lg:flex flex-column gap-2 mb-3 spacer-field" aria-hidden="true">
                        <label class="Label align-self-start">&nbsp;</label>
                        <Select class="w-full" show-clear size="small" variant="filled" />
                        <small class="error-text-block"></small>
                    </div>

                    <div class="flex flex-column gap-2 mb-3">
                        <label for="other_students" class="Label align-self-start">Other Students</label>
                        <InputText id="other_students" type="text"
                            placeholder="Type other students emails here (comma-separated)"
                            variant="filled" class="w-full" v-model="otherStudents"
                            :disabled="classModel !== 'group_class'" size="small" :invalid="!!errors.otherStudents" />
                        <small class="error-text-block">{{ errors.otherStudents }}</small>
                    </div>
                </div>
            </div>
            <div class="col-12 lg:col-10 grid justify-content-center align-items-center">
                <div class="flex flex-column gap-2 w-full mb-4 px-2">
                    <label for="areasToImprove" class="Label align-self-start">Specific areas you want to improve?</label>
                    <Textarea v-model="areasToImprove" variant="filled" autoResize rows="4" class="w-full" placeholder="Type any specific areas you want to improve here" />
                </div>
            </div>

            <div class="col-12 lg:col-10 grid justify-content-center align-items-center">
                <div class="flex flex-column gap-2 w-full mb-4 px-2">
                    <label for="note" class="Label align-self-start">Note</label>
                    <Textarea v-model="note" variant="filled" autoResize rows="4" class="w-full" placeholder="Type any additional notes here" />
                </div>
            </div>

            <div class="col-12 lg:col-10 grid justify-content-center align-items-center">
                <div class="flex flex-column gap-2 w-full mb-4 px-2">
                    <div class="flex align-items-center gap-2">
                        <Checkbox v-model="expectVerificationCall" inputId="expectVerificationCall" binary
                            class="orange-checkbox" />
                        <label for="expectVerificationCall" class="Label">I expect a verification call from the tutor before scheduling the class</label>
                    </div>
                    <div v-if="expectVerificationCall" class="verification-code-section">
                        <small class="verification-instruction">
                            Share the 6-digit code below with the tutor during the verification call, so the tutor can verify the call.
                        </small>
                        <div class="verification-code">{{ verificationCode }}</div>
                    </div>
                </div>
            </div>

            <div class="md:col-10 flex justify-content-start mb-4">
                <Button label="Request Class" class="orange-button mt-3 mx-2" @click="submitRequest"
                    :disabled="conflictedClasses" />
            </div>
        </div>

        <ConflictedClasses v-model="conflictedClasses" :data="conflictedData" />

        <!-- Disclaimer -->
        <div class="text-center w-full max-w-xl mx-auto pt-8 pb-4 sm:px-8 px-4">
            <h3 class="disclaimer-heading text-lg font-semibold mb-2" style="color: #dc2626;">Disclaimer</h3>
            <p class="text-700 text-sm m-0">
                All sessions must be conducted through the platform. ILearn'd Tutors is not responsible for any off-platform sessions or arrangements.
            </p>
        </div>

    </component>
</template>

<script setup>
import { publicProfile } from '@/api/tutor';
import PublicProfileLayout from "@/layout/PublicProfileLayout.vue";
// import { Button, DatePicker, InputText, ProgressSpinner, Select, Textarea } from 'primevue';
import { mixpanelService } from '@/services/mixpanel';
import { Button, Checkbox, InputText, ProgressSpinner, Select, Textarea } from 'primevue';
import { onMounted, ref, watch, defineProps } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import * as api from '@/api/student';
import { notifyError, notifyWarn } from '@/utils/notification';
// import { toLocalISOString } from '@/utils/cleanups';
import ConflictedClasses from '@/components/ConflictedClasses.vue';
import { defineEmits } from 'vue';
import { cleanupLables } from '@/utils/cleanups';
import { parseOtherStudentEmails, unregisteredEmailsFromError, unregisteredEmailsMessage, validateOtherStudentEmails } from '@/utils/otherStudents';

const props = defineProps({
    innerUseage: {
        type: Boolean,
        default: false,
        required: false
    },
    tutor: {
        type: String,
        required: false
    }
});
const route = useRoute();
const router = useRouter();
const role = ref("student")
const emit = defineEmits(['back']);

// --- STATE MANAGEMENT ---
const loading = ref(true);
const conflictedClasses = ref(false);
const conflictedData = ref([]);

// --- FORM DATA REFS ---
const grade = ref(null);
const subject = ref(null);
const language = ref(null);
// const classType = ref(null);
// const location = ref(null);
// const address = ref(null);
// const date = ref(null);
// const start = ref(null);
// const end = ref(null);
const classModel = ref(null);
const otherStudents = ref(null);
const areasToImprove = ref(null);
const note = ref(null);
const expectVerificationCall = ref(false);
const verificationCode = ref(null);


// --- SELECT OPTIONS REFS ---
const allGrades = ref([]);
const subjects = ref([]);
const languages = ref([]);
const tutorProfile = ref();

// Use constants for static options for clarity
// const CLASS_LOCATIONS = [
//     { name: "Tutor’s place", code: "tutors_place" },
//     { name: "Student’s place", code: "students_place" },
// ];
// const locations = ref(CLASS_LOCATIONS);

const classModels = ref([]);
// const classTypes = ref([]);
const tutorName = ref([]);
const errors = ref({});

// --- WATCHERS ---
watch(grade, (newGrade) => {
    if (newGrade) errors.value.grade = null;
    subject.value = null;
    subjects.value = [];
    classModel.value = null;
    classModels.value = [];
    if (newGrade?.entries) {
        subjects.value = newGrade.entries.map(entry => ({
            name: cleanupLables(entry.subject),
            code: entry.subject
        }));
    }
});

// watch(classType, (newClassType) => {
//     if (newClassType) errors.value.classType = null; // Clear error
//     // Reset location and address if class type is changed to online
//     if (newClassType !== 'physical') {
//         location.value = null;
//         address.value = null;
//     }
// });

// watch(location, (newLocation) => {
//     if (newLocation) errors.value.location = null; // Clear error
//     // Clear address if the tutor's place is selected
//     if (newLocation === 'tutors_place') {
//         address.value = tutorProfile.value?.address || null;
//         return
//     }
//     address.value = null;
// });

watch(classModel, (newClassModel) => {
    if (newClassModel) errors.value.classModel = null; // Clear error
    // Clear otherStudents email if class model is not group
    if (newClassModel !== 'group_class') {
        otherStudents.value = null;
    }
});

// Watchers for simple fields to clear errors immediately
watch(language, (val) => { if (val) errors.value.language = null; });
watch(subject, (newSubject) => {
    if (newSubject) errors.value.subject = null;
    classModel.value = null;
    classModels.value = [];
    if (!newSubject) return;
    const entry = grade.value?.entries?.find(e => e.subject === newSubject);
    if (!entry) return;
    const models = [];
    if (entry.individualClass?.available) {
        models.push({ name: `One-on-One Class (LKR. ${formatPrice(entry.individualClass.charge)})`, code: 'individual_class' });
    }
    if (entry.groupClass?.available) {
        models.push({ name: `Group Class (LKR. ${formatPrice(entry.groupClass.charge)})`, code: 'group_class' });
    }
    classModels.value = models;
});
// watch(date, (val) => { if (val) errors.value.date = null; });
// watch(start, (val) => { if (val) errors.value.start = null; });
// watch(end, (val) => { if (val) errors.value.end = null; });
// watch(address, (val) => { if (val) errors.value.address = null; });
watch(otherStudents, (val) => { if (val) errors.value.otherStudents = null; });
watch(expectVerificationCall, (val) => {
    verificationCode.value = val ? generateVerificationCode() : null;
});


const validateForm = () => {
    errors.value = {};

    if (!grade.value) errors.value.grade = "Grade is required";
    if (!subject.value) errors.value.subject = "Subject is required";
    if (!language.value) errors.value.language = "Language is required";
    // if (!classType.value) errors.value.classType = "Class type is required";
    if (!classModel.value) errors.value.classModel = "Class model is required";
    // if (!date.value) errors.value.date = "Date is required";
    // if (!start.value) errors.value.start = "Start time is required";
    // if (!end.value) errors.value.end = "End time is required";
    // if (classType.value === "physical" && !location.value)
    //     errors.value.location = "Class location is required";
    // if (location.value === "students_place" && !address.value)
    //     errors.value.address = "Location address is required";
    if (classModel.value === "group_class") {
        const otherStudentsError = validateOtherStudentEmails(otherStudents.value);
        if (otherStudentsError) errors.value.otherStudents = otherStudentsError;
    }

    return Object.keys(errors.value).length === 0;
};

// --- API & DATA FETCHING ---
const formatPrice = (amount) => {
    if (amount == null) return '0.00';
    return new Intl.NumberFormat('en-LK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
};

const generateVerificationCode = () => {
    return Math.floor(100000 + Math.random() * 900000);
};

const processProfileData = (profile) => {
    tutorName.value = profile.username || "";

    // Group flat teachingLevels entries by grade
    const gradeMap = {};
    (profile.teachingLevels || []).forEach(entry => {
        if (!gradeMap[entry.grade]) {
            gradeMap[entry.grade] = { grade: entry.grade, name: cleanupLables(entry.grade), entries: [] };
        }
        gradeMap[entry.grade].entries.push(entry);
    });
    allGrades.value = Object.values(gradeMap);

    languages.value = (profile.teachingLanguage || []).map(lang => ({
        name: cleanupLables(lang),
        code: lang
    }));

    tutorProfile.value = profile;
};

const fetchTutorProfile = async (tutorId) => {
    try {
        const response = await publicProfile(tutorId);
        processProfileData(response.data.data);
    } catch (error) {
        console.error("Error fetching tutor profile:", error);
    } finally {
        loading.value = false;
    }
};

const submitRequest = async () => {
    conflictedClasses.value = false;

    if (!validateForm()) {
        notifyError("Error", "Please fill all required fields.");
        return;
    }

    // if (await checkForConflicts()) return;
    // if(await checkForConflictsWithOthers()) return;

    const payload = {
        tutorId: route.params.tutorId ? route.params.tutorId : props.tutor,
        grade: grade.value.grade,
        subject: subject.value,
        language: language.value,
        // classType: classType.value,
        // date: toLocalISOString(date.value),
        // start: toLocalISOString(start.value),
        // end: toLocalISOString(end.value),
        classModel: classModel.value,
        // optional fields
        // classLocation: location.value,
        // locationAddress: address.value,
        otherStudents: parseOtherStudentEmails(otherStudents.value),
        areasToImprove: areasToImprove.value,
        note: note.value,
        expectVerificationCall: expectVerificationCall.value,
        verificationCode: expectVerificationCall.value ? verificationCode.value : null,
    }
    try {
        await api.requestAClass(payload);
        mixpanelService.track('Class Requested', {
            tutor_id: payload.tutorId,
            tutor_name: tutorName.value,
            subject: payload.subject,
            grade: payload.grade,
            language: payload.language,
            class_model: payload.classModel,
            timestamp: new Date().getTime()
        });

        router.push(`/student_dashboard/request-a-class/${tutorName.value}/success`);
    } catch (error) {
        console.error("Error submitting class request:", error);
        const responseData = error?.response?.data;
        const errorMsg = responseData?.message || "An error occurred. Please try again.";
        const unregisteredEmails = unregisteredEmailsFromError(error);

        if (error?.response?.status === 403) {
            notifyWarn("Limit Reached", errorMsg);
        } else if (unregisteredEmails.length > 0) {
            // Show the rejected emails under the field, not just a generic toast
            errors.value.otherStudents = unregisteredEmailsMessage(unregisteredEmails);
            notifyError("Unregistered students", errorMsg);
        } else {
            notifyError(responseData?.status || "Error", errorMsg);
        }
    }
};

// const checkForConflicts = async () => {
//     const payload = {
//         date: toLocalISOString(date.value),
//         start: toLocalISOString(start.value),
//         end: toLocalISOString(end.value),
//     }
//     try {
//         await api.checkConflicts(payload);
//         return false;
//     } catch (error) {
//         conflictedClasses.value = true;
//         conflictedData.value = error.response.data.data;
//         return true;
//     }
// }

// const checkForConflictsWithOthers = async () => {
//     const payload = {
//         date: toLocalISOString(date.value),
//         start: toLocalISOString(start.value),
//         end: toLocalISOString(end.value),
//         otherStudents: otherStudents.value?.split(",").map(email => email.trim()),
//     }
//     try {
//         await api.checkConflictsWithOtherStudents(payload);
//         return false;
//     } catch (error) {
//         if(!conflictedClasses.value) conflictedData.value = error.response.data.data;
//         else conflictedData.value = [...conflictedData.value, ...error.response.data.data];
//         conflictedClasses.value = true;
//         return true;
//     }
// }

onMounted(() => {
    let tutorId = route.params.tutorId;
    if (!tutorId) tutorId = props.tutor

    if (tutorId) {
        fetchTutorProfile(tutorId);
    } else {
        loading.value = false;
        notifyWarn("Warning", "Tutor information is missing.");
    }
});
const goBack = () => {
    if (props.innerUseage) {
        emit('back');
    } else {
        router.back();
    }
};
</script>

<style scoped>
/* Scoped styles are better than using p-3 surface-border directly on layout divs */
.card .p-divider-horizontal {
    margin: 0.5rem 0;
}

.spacer-field {
    visibility: hidden;
}

.error-text-block {
    color: #dc2626;
    font-size: 0.75rem;
    display: block;
    margin-top: 0.05rem;
    min-height: 0.85rem;
    line-height: 0.85rem;
    overflow-wrap: anywhere;
}

.verification-code-section {
    margin-top: 0.5rem;
    padding: 1rem;
    background: #fff7ed;
    border: 1px solid #fed7aa;
    border-radius: 0.5rem;
}

.verification-instruction {
    color: #7c3aed;
    display: block;
    margin-bottom: 0.75rem;
    font-size: 0.8rem;
    line-height: 1.2rem;
}

.verification-code {
    font-size: 2rem;
    font-weight: 700;
    letter-spacing: 0.35em;
    color: #dc2626;
    text-align: center;
    user-select: all;
}
</style>